import { IMO, VoyageImoModelBase } from './voyage-imo-model'
import { AuthService } from '../services/auth/auth-service'
import { StatusService } from '../services/status-services'
import { mapOnlineStatusData } from '../utils/helpers'
import { browserUptimeTracker } from '../utils/browser-uptime-tracker'

const env = (<any>window)['appenv']
const isVesselOnCloud = env.vesselOnCloud

export enum VoyageImoEventNames {
    MissingImo = 'missing-imo',
    UnauthorizedImo = 'unauthorized-imo',
    ImoUpdated = 'imo-updated',
    showImoPopup = 'show-imo-popup',
}

export class VoyageImoModelImpl extends VoyageImoModelBase {
    private _imo: IMO = null
    private _offlineSync: any = null

    constructor() {
        super()
        this.intialiseImo()
    }

    set imo(imo: IMO) {
        this._imo = imo

        if (isVesselOnCloud && imo) {
            AuthService?.setSessionVesselIMO(imo?.toString())
        }
    }

    get imo() {
        if (!this._imo) {
            if (isVesselOnCloud) {
                this.dispatchMissingImoEvent()
            } else return env?.vesselIMONumber
        }
        return this._imo
    }

    set offlineSync(data: any) {
        this._offlineSync = data
    }

    get offlineSync() {
        return this._offlineSync
    }

    dispatchMissingImoEvent() {
        this.dispatchEvent(new CustomEvent(VoyageImoEventNames.MissingImo))
    }

    dispatchUnauthorizedImoEvent() {
        this.dispatchEvent(new CustomEvent(VoyageImoEventNames.UnauthorizedImo))
    }

    intialiseImo() {
        if (isVesselOnCloud) {
            const sessionImo = AuthService.getSessionVesselIMO()

            if (sessionImo) {
                this.imo = parseInt(sessionImo)
                return
            } else {
                this.dispatchMissingImoEvent()
                return
            }
        }
        this.imo = env?.vesselIMONumber
    }

    async sendHeartBeat() {
        const payload = await mapOnlineStatusData()
        if (payload) {
            if (payload?.position?.timestamp) {
                const status = await StatusService.setOnlineStatus(payload)
                if (status === 'Updated') {
                    // Update last online timestamp for uptime tracker
                    browserUptimeTracker.updateLastOnlineTimestamp()
                }
            } else {
                console.warn(
                    'Payload timestamp is undefined, skipping setOnlineStatus.',
                )
            }
        } else {
            console.warn('Payload is null, skipping setOnlineStatus.')
        }
    }

}
